/**
 * Component sizes to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 */
const componentSize = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'default', value: '3rem', title: `Default` }
];
exports.componentSize = componentSize;
